import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { Input } from '../../ui/input';
import { Search } from 'lucide-react';

// "Add section" picker, grouped by category, from the backend registry.
export const AddSectionDialog = ({ open, onClose, registry, onAdd }) => {
  const [q, setQ] = useState('');
  const groups = {};
  (registry || []).filter((s) => !q || s.label.toLowerCase().includes(q.toLowerCase()) || s.description.toLowerCase().includes(q.toLowerCase())).forEach((s) => { (groups[s.category] ||= []).push(s); });
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="add-section-dialog">
        <DialogHeader><DialogTitle>Add a section</DialogTitle></DialogHeader>
        <div className="relative"><Search className="w-4 h-4 absolute left-3 top-3 text-neutral-400" /><Input className="pl-9" placeholder="Search sections…" value={q} onChange={(e) => setQ(e.target.value)} autoFocus data-testid="add-section-search" /></div>
        {Object.entries(groups).map(([cat, items]) => (
          <div key={cat}>
            <p className="label-overline mb-3">{cat}</p>
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {items.map((s) => (
                <button key={s.type} onClick={() => { onAdd(s.type); onClose(); }} data-testid={`add-section-${s.type}`}
                  className="text-left border border-neutral-200 p-4 hover:border-amber-500 hover:bg-amber-50/40 transition-colors">
                  <div className="font-medium text-neutral-900">{s.label}</div>
                  <p className="text-xs text-neutral-500 mt-1 line-clamp-2">{s.description}</p>
                  <p className="text-[11px] text-neutral-400 mt-2">{s.layouts.length} layout{s.layouts.length > 1 ? 's' : ''}{s.source ? ' · live data' : ''}</p>
                </button>
              ))}
            </div>
          </div>
        ))}
      </DialogContent>
    </Dialog>
  );
};
